//Open data
export const FILTER_PARAMS_TO_REMOVE = [
    'derechos',
    'type',
    'ods',
    'odsId',
    'priorityGroups',
    'priorityGroupsId',
    'dimensiones',
    'variables'
];

export const SEARCH_PARAMS_TO_REMOVE = ['type', 'indicatorID', 'search', 'searchMode'];